var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"fa-3x text-primary fixed left-0 top-0 bg-dark bg-opacity-75 w-full h-full flex items-center justify-center z-50"},[_c('i',{staticClass:"fas fa-sync fa-spin "})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }